/* eslint-disable no-unused-vars */
import React, { useContext, useEffect, useState } from 'react';
import Grid from '@mui/material/Unstable_Grid2';
import { Box, Button } from '@mui/material';
import { DataGridPro } from '@mui/x-data-grid-pro';
import useSalesWeeklyReportContext from '../context/useSalesWeeklyReportContext';

export default function Table() {
  //
  const { loading, salesReport, handleReportExport } = useContext(useSalesWeeklyReportContext);
  const [sortModel, setSortModel] = useState([
    {
      field: 'date_scheduled',
      sort: 'desc',
    },
  ]);

  const handlePerfCellClassName = (value) => {
    let className;

    if (parseFloat(value) >= 1) {
      className = 'cell-green';
    }

    if (parseFloat(value) < 1) {
      className = 'cell-red';
    }

    return className;
  };

  const columns = [
    {
      field: 'md_code',
      headerName: 'MD Code',
      width: 200,
      flex: 1,
    },
    {
      field: 'md_name',
      headerName: 'MD Name',
      width: 200,
      flex: 1,
    },
    {
      field: 'specialty',
      headerName: 'Specialty',
      width: 200,
      flex: 1,
    },
    {
      field: 'rep_name',
      headerName: 'MPR',
      width: 200,
      flex: 1,
    },
    {
      field: 'md_group',
      headerName: 'Group',
      width: 200,
      flex: 1,
    },
    {
      field: 'date_scheduled',
      headerName: 'Date Schedule',
      width: 200,
      flex: 1,
    },
    {
      field: 'date_completed',
      headerName: 'Date Presented',
      width: 200,
      flex: 1,
    },
    {
      field: 'product_558',
      headerName: 'FENAL',
      width: 200,
      flex: 1,
      cellClassName: ({ row }) => handlePerfCellClassName(row.product_558),
    },
    {
      field: 'product_560',
      headerName: 'NEFRAL',
      width: 200,
      flex: 1,
      cellClassName: ({ row }) => handlePerfCellClassName(row.product_560),
    },
    {
      field: 'product_606',
      headerName: 'PRONERV',
      width: 200,
      flex: 1,
      cellClassName: ({ row }) => handlePerfCellClassName(row.product_606),
    },
    {
      field: 'product_610',
      headerName: 'VILANTRA',
      width: 200,
      flex: 1,
      cellClassName: ({ row }) => handlePerfCellClassName(row.product_610),
    },
    {
      field: 'product_699',
      headerName: 'PIXAB',
      width: 200,
      flex: 1,
      cellClassName: ({ row }) => handlePerfCellClassName(row.product_699),
    },
    {
      field: 'product_702',
      headerName: 'ENPLUS',
      width: 200,
      flex: 1,
      cellClassName: ({ row }) => handlePerfCellClassName(row.product_702),
    },
    {
      field: 'product_751',
      headerName: 'VIGLIPTIC',
      width: 200,
      flex: 1,
      cellClassName: ({ row }) => handlePerfCellClassName(row.product_751),
    },
  ];

  const pinnedRows = {
    bottom: salesReport.length ? [salesReport[0]] : [],
  };

  return (
    <Grid container spacing={2}>
      <Grid xs={12} sm={12} md={12}>
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'flex-end',
          }}
        >
          <Button
            variant='contained'
            color='success'
            onClick={handleReportExport}
            sx={{
              marginLeft: '20px',
              marginBottom: '20px',
              paddingTop: '10px',
            }}
          >
            Export Report Summary
          </Button>
        </Box>
        <Box
          className='table-container'
          sx={{
            height: '800px',
            marginLeft: '20px',
            '& .cell-green': {
              backgroundColor: '#5cb85c',
              color: '#000',
              fontWeight: '600',
            },

            '& .cell-red': {
              backgroundColor: '#d9534f',
              color: '#000',
              fontWeight: '600',
            },
            '& .MuiDataGrid-pinnedRows': { fontWeight: 'bold', backgroundColor: '#5cb85c' },
          }}
        >
          <DataGridPro
            className='datagrid-sales-report'
            rows={salesReport}
            columns={columns}
            loading={loading}
            sortModel={sortModel}
            pinnedRows={pinnedRows}
            experimentalFeatures={{ rowPinning: true }}
            initialState={{
              ...salesReport.initialState,
              pagination: { paginationModel: { pageSize: 50 } },
            }}
            pageSizeOptions={[25, 50, 75, 100]}
            pagination
            onSortModelChange={(model) => setSortModel(model)}
          />
        </Box>
      </Grid>
    </Grid>
  );
}
